<template>
    <PlanoBanner :status="status">
        <div class="item">
            <header>
                <SystemTypeIcon v-if="!dense" class="pointer" :type="item.template.systemType.id" @click="openPlano"></SystemTypeIcon>
                <div>
                    <h1 class="pointer" @click="openPlano">{{ item.name }}</h1>
                    <h2>{{ item.campaign.name }} /// {{ item.zone.name }}</h2>
                    <h3>{{ item.height }} x {{ item.width }}</h3>
                </div>
            </header>
            <AddToBasket v-if="canAddToBasket" id="add2basket" :item="item"></AddToBasket>

            <table>
                <tbody>
                    <tr v-if="item.isLocked">
                        <Lock></Lock>
                        <label class="lock">{{ item.lockedBy.initial }} /// {{ item.lockedAt }}</label>
                    </tr>
                    <tr>
                        <PopupMenu>
                            <td class="options">{{ $trad.planoList.option }}</td>
                            <ul slot="items">
                                <li @click="$emit('showDuplicateModal', item);">{{ $trad.planoList.duplicate }}</li>
                                <hr v-if="!item.isLocked" />
                                <li v-if="!item.isLocked" @click="$emit('openEditNameModal', item, $event);">{{ $trad.planoList.editName }}</li>
                                <li v-if="!item.isLocked && hasAccessDelete('plano_builder')" @click="deletePlano">{{ $trad.planoList.delete }}</li>
                                <li
                                    v-if="!item.isLocked && hasAccessUpdate('plano_builder') && item.status === 'IN PROGRESS'"
                                    @click="$emit('version', item.id, item.name);"
                                >
                                    {{ $trad.planoList.history }}
                                </li>

                                <li
                                    v-for="(action, index) in workflows"
                                    :key="index"
                                    @click="$emit('changeStatusPlano', item.id, action, 'updateStatus');"
                                    :style="{ backgroundColor: action.color, color: 'white' }"
                                >
                                    {{ $tradFor(action.terms.name) }}
                                </li>
                                <li v-if="!item.isLocked" class="archive" @click="$emit('archivedPlano', item, 'updateArchive');">
                                    {{ item.archived ? $trad.StatStatus.labelDesarchived : $trad.StatStatus.labelArchived }}
                                </li>
                            </ul>
                        </PopupMenu>
                    </tr>
                    <tr>
                        <td>
                            <span class="cell">id {{ item.id }}</span>
                            <span class="cell pointer" @click="$emit('modalComment', item.id);">
                                {{ item.nbComments }} <i class="fa fa-comment"></i>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td><Status :value="item.status"></Status></td>
                        <td v-if="!dense"><AuthorBadge label="M" :author="item.modifiedUser.initial" :date="item.modifiedDate"></AuthorBadge></td>
                        <td v-if="!dense"><AuthorBadge label="C" :author="item.createdUser.initial" :date="item.createdAt"></AuthorBadge></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </PlanoBanner>
</template>

<script>
import PlanoBanner from "./components/plano-banner";
import AuthorBadge from "./components/author-badge";
import Status from "./components/status";
import AddToBasket from "./components/add-to-basket.vue";
import PopupMenu from "./components/popup-menu";
import Lock from "./components/lock";
import SystemTypeIcon from "./SystemTypeIcon";
import httpService from "@/components/service";
import { i18n } from "@/main.js";
import cacheService from "@/services/cache";

export default {
    components: { PlanoBanner, SystemTypeIcon, AuthorBadge, Status, AddToBasket, Lock, PopupMenu },
    props: {
        item: {
            type: Object,
            required: true
        },
        dense: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        status() {
            return this.item.status && this.item.status.toLowerCase().replace(" ", "_");
        },
        canAddToBasket() {
            return (
                this.item.status === "APPROVED" &&
                this.item.template.systemType.name === "shelf" &&
                this.item.price &&
                this.hasClientAccess("orders_manager", ...this.AccessUser.CONTRIBUTE)
            );
        },
        workflows() {
            if (this.item.isLocked) return [];
            return this.item.workflow.filter(action => {
                if (action.archived || action.show !== "true") return false;
                if (this.hasAccessSuperAdmin("plano_builder")) return true;
                return this.ifUserHasCreatedThisPlano(this.item.createdUser.id);
            });
        }
    },
    methods: {
        // TODO: rewrite this entire ugly code
        deletePlano() {
            const idx = this.item.id;
            const name = this.item.name;
            let confirmTitle;
            let warningText;
            let confirmDelete;
            if (i18n.locale === "fr") {
                confirmTitle = "Supprimer le planogramme <br>" + name + " ?";
                warningText = "Etes-vous de vouloir supprimer ? Vous ne pourrez plus revenir en arrière!";
                confirmDelete = "Oui, supprimer!";
            } else if (i18n.locale === "en") {
                confirmTitle = "Delete the plano <br>" + name + " ?";
                warningText = "Are you sure? You won't be able to revert this!";
                confirmDelete = "Yes, delete it!";
            }
            this.$swal({
                title: confirmTitle,
                text: warningText,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#41b4e8",
                confirmButtonText: confirmDelete,
                closeOnConfirm: true
            }).then(result => {
                if (result === true) {
                    httpService.delete("/plano/" + idx + "/delete").then(function(response) {
                        location.reload();
                    });
                } else {
                }
            });
        },
        ifUserHasCreatedThisPlano(createdPlanoUserId) {
            let userConnectId = cacheService.getRem3rchUser().user.id;
            return !!(createdPlanoUserId === userConnectId);
        },
        openPlano() {
            this.$emit("openPlano", this.item);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

label.lock {
    display: block;
    text-align: right;
    font-size: 10px;
    text-transform: none;
    color: #898989;
    margin-top: 5px;
}

.archive {
    background: #a3a3a3;
    color: white;
}

div.item {
    position: relative;
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 20px 0;

    #add2basket {
        position: absolute;
        top: 8px;
        left: 35%;
    }

    header {
        display: grid;
        grid-template-columns: auto auto;
        column-gap: 8px;
        align-items: center;
        font-family: Oswald, Sans-Serif;
        margin-left: 8px;

        > div * {
            margin: 0;
            font-weight: 500;
        }

        h1 {
            @extend %second-text;
            font-size: 19px;

            &:hover {
                text-decoration: underline;
            }
        }
        h2 {
            color: var(--color4);
            font-size: 17px;
        }
        h3 {
            @extend %second-text;
            font-size: 11px;
        }
    }

    table {
        height: 100%;
        flex-shrink: 0;
        float: right;
        direction: rtl;

        color: white;
        .light & {
            color: #727272;
        }

        tr {
            direction: initial;

            .cell {
                display: inline-block;
                border: 1px #a8a8a8 solid;
                height: 27px;
                line-height: 27px;
                padding: 0 5px;
            }

            .options::after {
                display: inline-block;
                width: 0;
                height: 0;
                margin-left: 0.255em;
                vertical-align: 0.255em;
                content: "";
                border-top: 0.3em solid;
                border-right: 0.3em solid transparent;
                border-bottom: 0;
                border-left: 0.3em solid transparent;
                margin-top: 4px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// plano-list-item.vue?1fa5599b